export var tableHeaderSortableCellTheme = {
  baseStyle: _ref => {
    var {
      isSorting,
      textAlign,
      isClickable
    } = _ref;
    return {
      icon: {
        display: 'inline-flex',
        alignItems: 'center',
        opacity: isSorting || !isClickable && isSorting ? 1 : 0,
        transition: 'opacity 0.25s ease',
        order: textAlign === 'end' ? -1 : 'initial',
        _hover: {
          opacity: 1
        }
      }
    };
  },
  defaultProps: {
    textAlign: 'start'
  }
};
//# sourceMappingURL=_TableHeaderSortableCell.theme.js.map